import jobDeferApi from './graphql/jobDeferApi';
import jobUndeferByTicketApi from './graphql/jobUndeferByTicketApi';
import { nextId } from '../../utils';
import jobUnreviewApi from './graphql/jobUnreviewApi';
import { createJobInvoiceApi } from './graphql/sendJobToSage';
import { getSelectedTicketId } from './selectors';
import { jobStateChangeApi } from './graphql/jobStateChangeApi';

export const types = {
  SELECT_JOB_ID: 'ticketInvoicing/SELECT_JOB_ID',
  SELECT_TICKET_ID: 'ticketInvoicing/SELECT_TICKET_ID',
  VIEW_JOBS: 'ticketInvoicing/VIEW_JOBS',
  VIEW_DEFERRED_JOBS: 'ticketInvoicing/VIEW_DEFERRED_JOBS',
  SET_ERROR_MESSAGE: 'ticketInvoicing/SET_ERROR_MESSAGE',
  CLEAR_ERROR_MESSAGE: 'ticketInvoicing/CLEAR_ERROR_MESSAGE',
  SET_SORTED: 'ticketInvoicing/SET_SORTED',
};


export const selectTicketId = (ticketId) => {
  return {
    type: types.SELECT_TICKET_ID,
    ticketId,
  };
};


export const selectJobId = (jobId) => {
  return {
    type: types.SELECT_JOB_ID,
    jobId,
  };
};


export const viewJobs = () => {
  return {
    type: types.VIEW_JOBS,
  };
};


export const viewDeferredJobs = () => {
  return {
    type: types.VIEW_DEFERRED_JOBS,
  };
};

export const setErrorMessage = (errorMessage) => {
  return {
    type: types.SET_ERROR_MESSAGE,
    errorMessage,
  };
};

export const clearErrorMessage = () => {
  return {
    type: types.CLEAR_ERROR_MESSAGE,
  };
};

export const setSorted = (sorted) => {
  return {
    type: types.SET_SORTED,
    sorted,
  };
};


export const deferJobId = (jobId) => {
  return async (dispatch, getState, { client }) => {
    const { oldCollection, id } = await jobDeferApi(client, jobId);
    const nextJobId = nextId(oldCollection, jobId);
    dispatch(selectJobId(nextJobId));
    return id;
  };
};


export const undeferJobByTicketId = (ticketId, jobId) => {
  return async (dispatch, getState, { client }) => {
    const { oldCollection, result } = await jobUndeferByTicketApi(client, ticketId, jobId);
    const { ticket_undefer_job: monthLeaseDestroyed } = result.data;

    if (monthLeaseDestroyed) {
      const nextJobIdId = nextId(oldCollection, jobId);
      dispatch(selectJobId(nextJobIdId));
    }
  };
};


export const unreviewJobId = (jobId, reason) => {
  return async (dispatch, getState, { client }) => {
    const { oldCollection } = await jobUnreviewApi(client, jobId, reason);
    const nextJobId = nextId(oldCollection, jobId);
    dispatch(selectJobId(nextJobId));
  };
};

export const sendJobToSage = (jobId) => {
  return async (dispatch, getState, { client }) => {
    const state = getState();
    const ticketId = getSelectedTicketId(state);

    await createJobInvoiceApi(client, jobId, ticketId);
  };
};

export const bypassSage = (jobId) => {
  return async (dispatch, _getState, { client }) => {
    const { oldCollection } = await jobStateChangeApi(client, jobId, 'completed');
    const nextJobId = nextId(oldCollection, jobId);
    dispatch(selectJobId(nextJobId));
  };
};
